<template>
    <div class="canvas-box" ref="canvasBox">
        <div class="line-option" ref="lineOption" v-if="!svgShow">
            <div class="line-option-row" v-for="(row,i) in options" :key="i">
                <div class="line-option-column" v-for="(column,n) in row" :key="n">
                    <span class="raw" v-katex="column.content"></span>
                </div>
            </div>
        </div>
        <svg v-if="svgShow" xmlns="http://www.w3.org/2000/svg" version="1.1" :width="width" :height="height">
            <foreignObject v-for="(item,index) in svgTextPos" :key="'text'+index"  :x="item.x" :y="item.y" :width="item.w" :height="item.h">
                <p style="line-height:24px;" xmlns="http://www.w3.org/1999/xhtml" v-html="item.content"></p>
            </foreignObject>
            <line v-for="(item,index) in svgLinePos" :key="'line'+index" :x1="item[0]" :y1="item[1]" :x2="item[2]" :y2="item[3]" style="stroke:#666;stroke-width:1"/>
        </svg> 
    </div>
</template>

<script>
export default {
    props:['answer','options'],
    data(){
        return{
            width:0,
            height:0,
            contentBox:null,
            positions:[{content: "1. 第一列的答案1",h: 24,w: 108,x: 0,y: 0}],
            svgShow: false,
        }
    },
    mounted(){
        this.setCanvas()
    },
    methods:{
        setCanvas(){
            this.positions.splice(0,this.positions.length)
            this.$nextTick(()=>{
                this.contentBox = this.$refs.lineOption
                this.width = this.contentBox.clientWidth
                this.height = this.contentBox.clientHeight
                this.getPositions()
                this.svgShow = true
            })
        },
        // 获得坐标
        getPositions(){
            let rows = this.contentBox.children
            let x = 0
            for(let i = 0; i < rows.length; i++){
                let y = 0
                let columns = rows[i].children
                this.positions.push([])
                for(let n = 0; n < columns.length; n++){
                    let h = columns[n].children[0].clientHeight
                    let w = columns[n].children[0].clientWidth
                    this.positions[i].push({x:x,y:y,w:w+1,h:h,content:columns[n].children[0].innerHTML})
                    y = y+h
                }
                x = x+rows[i].clientWidth
            }
        },
    },
    computed:{
        svgTextPos(){
            let arr = []
            this.positions.forEach(el=>{
                arr = [...arr,...el]
            })
            return arr
        },
        svgLinePos(){
            let arr = []
            try {
                this.answer.forEach(el => {
                    let row = el.split(',')
                    row.forEach((y,x)=>{
                        if(x > 0){
                            let start = [x-1,Number(row[x-1])-1]
                            let end = [x,Number(y)-1]
                            let s = this.positions[start[0]][start[1]]
                            let e = this.positions[end[0]][end[1]]
                            this.positions[start[0]].forEach(el=>{
                                if(el.w > s.w){
                                    s.w = el.w
                                }
                            })
                            arr.push([s.x+s.w,s.y+s.h/2,e.x,e.y+e.h/2])
                        }
                    })
                });
            } catch (error) {
                console.log(error);
            }
            return arr
        },
        propsData(){
            let options = JSON.stringify(this.options)
            let answer = JSON.stringify(this.answer)
            return options + answer
        }
    },
    watch:{
        propsData(){
            this.svgShow = false
            this.setCanvas()
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-single/src/lineOption.vue